import { useState, useEffect } from 'react';
import { getCourseBundlesList } from '../services/courseBundleService';

const COURSE_BUNDLES_DATA_SESSION_KEY = 'courseBundlesData';

const useCourseBundlesData = () => {
  // check if data already in session. If true, initialize state with that value
  let defaultCourseBundlesData = null;
  const courseBundlesDataStr = sessionStorage.getItem(
    COURSE_BUNDLES_DATA_SESSION_KEY
  );
  if (courseBundlesDataStr) {
    defaultCourseBundlesData = JSON.parse(courseBundlesDataStr);
  }

  const [loadingCourseBundlesData, setLoadingCourseBundlesData] = useState(
    false
  );
  const [error, setError] = useState('');
  const [courseBundlesData, setCourseBundles] = useState(
    defaultCourseBundlesData
  );

  const courseBundleOptions = courseBundlesData
    ? courseBundlesData.map(({ slug, title }) => ({
        label: title,
        value: slug,
      }))
    : [];

  useEffect(() => {
    const fetchCourseBundles = async () => {
      // check id data already in session or already loading
      if (sessionStorage.getItem(COURSE_BUNDLES_DATA_SESSION_KEY)) return;

      setLoadingCourseBundlesData(true);
      const { data, error } = await getCourseBundlesList();
      setLoadingCourseBundlesData(false);

      if (error || !Array.isArray(data)) {
        setError(error);
        return;
      }

      sessionStorage.setItem(
        COURSE_BUNDLES_DATA_SESSION_KEY,
        JSON.stringify(data)
      );
      setCourseBundles(data);
    };

    fetchCourseBundles();
  }, []);

  return {
    loadingCourseBundlesData,
    courseBundlesData,
    error,
    courseBundleOptions,
  };
};
export default useCourseBundlesData;
